
import { environment } from '../../../environments/environment';

const baseURL = environment.baseURL;

export const ApiUrls = {
    login: `${baseURL}admin/login`,
    forgotPassword: `${baseURL}admin/forgotPassword`,
    resetPassword: `${baseURL}admin/resetPassword/`,
    verifyOtp: `${baseURL}admin/verifyOtp`,
    resendOtp: `${baseURL}admin/resendOtp`,
    changePassword: `${baseURL}admin/changePassword`,
    // profile
    profile: `${baseURL}admin/myProfile`,
    editProfile: `${baseURL}admin/updateProfile`,
    // dashboard
    dashboard: `${baseURL}admin/dashboard`,
    // faq
    faqList: `${baseURL}static/faqList`,
    addFaq: `${baseURL}static/addFaq`,
    editFaq: `${baseURL}static/editFaq`,
    deleteFaq: `${baseURL}static/deleteFaq`,
    viewFaq: `${baseURL}static/viewFaq`,
    // static content
    staticContentList: `${baseURL}static/staticContentList`,
    editStaticContent: `${baseURL}static/editStaticContent`,
    viewStaticContent: `${baseURL}static/viewStaticContent`,
    // Program management
    addProgram: `${baseURL}admin/addProgram`,
    programList: `${baseURL}admin/programList`,
    viewProgram: `${baseURL}admin/viewProgram`,
    editProgram: `${baseURL}admin/editProgram`,
    deleteProgram: `${baseURL}admin/actionPerform_program`,
    // Questionnaire /api/v1/admin/editQuestionnaire
    addQuestionnaire: `${baseURL}admin/addQuestionnaire`,
    questionnaireList: `${baseURL}admin/questionnaireList`,
    viewQuestionnaire: `${baseURL}admin/viewQuestionnaire`,
    actionPerform_questionnaire: `${baseURL}admin/actionPerform_questionnaire`,
    editQuestionnaire: `${baseURL}admin/editQuestionnaire`,

    //Therapist Management 
    addTherapist: `${baseURL}admin/addTherapist`,
    therapistList: `${baseURL}admin/therapistList`,
    actionPerform_therapist: `${baseURL}admin/actionPerform_therapist`,
    editTherapist: `${baseURL}admin/editTherapist`,
    viewTherapist: `${baseURL}admin/viewTherapist`,
    // upload Image api 

    uploadImage: `${baseURL}admin/uploadImage`,

    // Library Management
    addLibrary: `${baseURL}admin/addLibrary`,
    library_list: `${baseURL}admin/library_list`,
    library_view: `${baseURL}admin/library_view`,
    actionPerform_library: `${baseURL}admin/actionPerform_library`,

    // Transaction management
    transactionList: `${baseURL}admin/transactionList`,

    // Journal Management 
    journalQuestion_list: `${baseURL}admin/journalQuestion_list`,
    view_journalQuestion: `${baseURL}admin/view_journalQuestion`,
    update_journalQuestion: `${baseURL}admin/update_journalQuestion`,
    // Subadmin Management
    addSubadmin: `${baseURL}admin/addSubadmin`,
    subadminList: `${baseURL}admin/subadminList`,
    actionPerform: `${baseURL}admin/actionPerform`,
    viewSubadmin: `${baseURL}admin/viewSubadmin`,
    editSubadmin: `${baseURL}admin/editSubadmin`,

    // Patient Management /api/v1/admin/assign_program
    addPatient: `${baseURL}admin/addPatient`,
    patientList: `${baseURL}admin/patientList`,
    viewPatient: `${baseURL}admin/viewPatient`,
    editPatient: `${baseURL}admin/editPatient`,
    actionPerform_patient: `${baseURL}admin/actionPerform_patient`,
    patient_notes_list: `${baseURL}admin/patient_notes_list`,
    patient_assessmentList: `${baseURL}admin/patient_assessmentList`,
    patient_sessionList: `${baseURL}admin/patient_sessionList`,
    assign_program: `${baseURL}admin/assign_program`,

    // Assessment Management //api/v1/admin/feedback_List
    addAssessment_Form: `${baseURL}admin/addAssessment_Form`,
    assessmentForm_List: `${baseURL}admin/assessmentForm_List`,
    actionPerform_assessmentForm: `${baseURL}admin/actionPerform_assessmentForm`,
    assessmentForm_view: `${baseURL}admin/assessmentForm_view`,
    editAssessment_Form: `${baseURL}admin/editAssessment_Form`,

    // Feedback list //api/v1/admin/actionPerform_feedback
    feedback_List: `${baseURL}admin/feedback_List`,
    view_feedback: `${baseURL}admin/view_feedback`,
    actionPerform_feedback: `${baseURL}admin/actionPerform_feedback`,
    // drinking Diary list api 

    drinkingDairy_details: `${baseURL}admin/drinkingDairy_details`,

    // get slot list api //api/v1/admin/blockSlot
    getSlotFor_booking: `${baseURL}admin/getSlotFor_booking`,
    assignTherapist: `${baseURL}admin/assignTherapist`,
    blockSlot: `${baseURL}admin/blockSlot`,
    unblockSlot: `${baseURL}admin/unblockSlot`,
    setSlot: `${baseURL}admin/setSlot`,

    // chat Apis
    sendMessage: `${baseURL}chat/chatAPI`,
    chatHistory: `${baseURL}chat/chatHistory`,

    // Notification Api list /api/v1/admin/userList
    notification_list: `${baseURL}admin/notification_list`,
    sendNotification: `${baseURL}admin/sendNotification`,
    userList: `${baseURL}admin/userList`,

    // Query Management 
    query_List: `${baseURL}admin/query_List`,
    view_query: `${baseURL}admin/view_query`,
    actionPerform_query: `${baseURL}admin/actionPerform_query`,

    // Program Type Management //api/v1/admin/programType_view
    programType_add: `${baseURL}admin/programType_add`,
    programType_list: `${baseURL}admin/programType_list`,
    programType_edit: `${baseURL}admin/programType_edit`,
    actionPerform_programType: `${baseURL}admin/actionPerform_programType`,
    programType_view: `${baseURL}admin/programType_view`
    
}
